import React, { useEffect, useRef } from 'react';
/** lib **/
import { useScrollToAnchor } from 'lib/use-scroll-anker-link';
/** components **/
import {
  KeyVisual,
  TopNews,
  IssuesInPetOwnership,
  PossibleItems,
  AreaFloorPlanRent,
  OurPartner,
  TopSupporterVoice,
  Layout,
  TopComics,
} from 'components/organisms';
import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';
import LeadContentsImage from 'assets/images/lead-contents-image.png';
import { REGISTER_FORM_URL } from 'const';
/** styles **/
import s from '../styles/pages/top.module.scss';

export const Top: React.FC = () => {
  const { scrollToAnchor } = useScrollToAnchor({ smooth: true });
  const inViewRef1 = useRef<HTMLHeadingElement>(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const animationEl = [inViewRef1];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(s.inview);
          } else {
            entry.target.classList.remove(s.inview);
          }
        });
      },
      {
        root: null,
        rootMargin: '-90% 0px 20% 0px',
        threshold: 0,
      },
    );
    animationEl.forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      animationEl.forEach((ref) => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });
    };
  }, [animationEl]);

  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_path: '/',
      });
    }
  }, []);

  useEffect(() => {
    scrollToAnchor();
  }, [scrollToAnchor]);


  return (
    <Layout>
      <div id="top" className={s.topWrapper}>
        <div className={s.kv} ref={inViewRef1}>
          <KeyVisual />
        </div>
        <div className={s.leadContents}>
          <div className={s.imageWrapper}>
            <div className={s.text}>
              <p>現在の会員数</p>
              <p className={s.number}>2,972 <span>人</span></p>
            </div>
            <img src={LeadContentsImage} alt="ピーワン" />
          </div>
          <div className={s.textWrapper}>
            <h3>あなたの ”あったらいいな” が<br className={s.spOnly} />現実になるかも？<br />
              会員登録をして皆さまの意見やアイディアをぜひお聞かせください。
            </h3>
            <a className={s.linkToForm} href={REGISTER_FORM_URL} target="_blank" rel="noreferrer">
              会員登録（無料）
              <GreenCircleArrow className={s.arrowIcon} />
            </a>
          </div>
        </div>
        <div id="news">
          <TopNews />
        </div>
        <div id="issue">
          <IssuesInPetOwnership />
        </div>
        <PossibleItems />
        <TopComics />
        <div id="supporter-voice">
          <TopSupporterVoice />
        </div>
        <div id="area">
          <AreaFloorPlanRent />
        </div>
        <div id="partner">
          <OurPartner />
        </div>
      </div>
    </Layout>
  );
};
